import ShareProvider from './hooks/useShare';

import { ShareProps } from './@types/ShareProps';
import ShareContainer from './handles/ShareContainer';
import ShareLabel from './handles/ShareLabel';
import ShareButtons from './handles/ShareButtons';

const Share = (props: ShareProps) => (
	<ShareProvider {...props}>
		<ShareContainer>
			<ShareLabel />
			<ShareButtons />
		</ShareContainer>
	</ShareProvider>
);

export default Share;
